function lerp(start, end, amt) {
	return (1 - amt) * start + amt * end
}


class RyderMarquee {
	constructor(el, setting) {
		this.hero = $(el).parent().get(0)
		this.wrapper = el
		this.delta = 0
		this.transform = 0
		this.loopSize = 0
		this.step = 1.5
		this.direct = 0
		this.vertical = false
		this.stopOnHover = false
		this.isHover = false
		this.isAcc = false
		this.acc = 0.5
		this.originalChildrenCount = el.children.length

		Object.assign(this, setting)


		if (device == 'mobile') {
			this.step /= 2
			this.acc /= 2
		}

		this.loopSize = this.measureLoopSize()

		if (this.direct == 1) {
			this.transform = -this.loopSize || 0
			this.applyTransform()
		}

		if (this.stopOnHover) {
			$(el).hover(() => {
				this.isHover = true
			}, () => {
				this.isHover = false
			})
		}
	}

	measureLoopSize() {
		const children = Array.from(this.wrapper.children).slice(0, this.originalChildrenCount);

		if (!children.length) {
			return this.vertical
				? this.wrapper.getBoundingClientRect().height / 2
				: this.wrapper.getBoundingClientRect().width / 2;
		}

		return children.reduce((total, child) => {
			return total + (this.vertical ? $(child).outerHeight(true) : $(child).outerWidth(true));
		}, 0);
	}

	applyTransform() {
		if (!this.vertical) {
			this.wrapper.style.transform = `translate3d(${this.direct == 1 ? this.transform : -this.transform}px, 0, 0)`;
		} else {
			this.wrapper.style.transform = `translate3d(0, ${this.direct == 1 ? this.transform : -this.transform}px, 0)`;
		}
	}

	animate() {
		this.loopSize = this.measureLoopSize();

		this.delay = 50;

		if (this.velo != null) {
			this.delta = lerp(this.delta, this.scrollY - this.velo, 0.1);
		}

		if (this.delta < 0) {
			this.delta = 0;
		}

		this.velo = this.scrollY;

		clearTimeout(this.timer);

		this.timer = setTimeout(() => this.clear(), this.delay);


		if (!this.isHover) {
			this.transform += this.step
		}

		if (this.direct == 1) {
			if (this.transform > 0) {
				this.transform = -this.loopSize;
			}

			if (this.isAcc) {
				this.transform += 0.5 + (this.delta * this.acc);
			}
		} else {
			if (this.transform > this.loopSize) {
				this.transform = 0;
			}

			if (this.isAcc) {
				this.transform += 0.5 + (this.delta * this.acc);
			}
		}

		this.applyTransform();
	}

	render() {
		this.scrollY = $(window).scrollTop()

		const bounding = this.hero.getBoundingClientRect();
		const distance = (window.innerHeight + this.scrollY) - (bounding.top + this.scrollY);
		const percentage = distance / ((window.innerHeight + bounding.height) / 100);

		this.animate();
	}

	clear() {
		this.delta = 0;
		this.velo = null;
	}

	create() {
		gsap.ticker.add(this.render.bind(this));
	}
}



function marqueeHandler(el, options = {}) {
	const {
		direct = 0, //0是往左 1是往右
		step = null, //移動速度
		stopOnHover = false, //hover時停止
		isAcc = false, //是否滾動時加速
		acc = 0.5, //滾動時的加速度
		vertical = false, //直式
	} = options;

	const originalChildrenCount = el.children.length;
	const loopSize = Array.from(el.children).reduce((total, child) => {
		return total + (vertical ? $(child).outerHeight(true) : $(child).outerWidth(true));
	}, 0);

	let $copy = $(el).contents().clone();
	$(el).append($copy);

	let ryderOptions = {
		direct,
		stopOnHover,
		isAcc,
		acc,
		vertical,
		loopSize,
		originalChildrenCount,
	};

	if (step !== null) {
		ryderOptions.step = step;
	}

	let ryderMarquee = new RyderMarquee(el, ryderOptions).create();
}


export {
	marqueeHandler,
}
